import { graphql } from '@shared/api/gql';

// The tenant app's own id in `system`. Fetched once per device and then
// stamped on every reader event (`@shared/events`' `app_id`).
export const appIdQueryDocument = graphql(`
	query AppId {
		app {
			id
		}
	}
`);
